import React from "react";

const Label = ({ label, labelColor, fontSize, fontWeight }) => {
  return (
    <span
      style={{
        textAlign: "left",
        fontWeight: fontWeight ?? 700,
        fontSize: fontSize ?? "16px ",
        color: labelColor ?? "black",
        marginBottom: "8px",
        width: "auto",
      }}
    >
      {label}
    </span>
  );
};

export default Label;
